const MAX_ACTIVE_COURSES = 3;

const plural = (count: number, word: string): string => `${count} ${word}${count === 1 ? '' : 's'}`;

export const getActiveCoursesMessage = (activeCount: number, pausedCount: number): string => {
  if (activeCount >= MAX_ACTIVE_COURSES) {
    return `You have ${plural(activeCount, 'active course')} and have reached the maximum limit. Pause a course to start a new one.`;
  }

  const remaining = MAX_ACTIVE_COURSES - activeCount;

  if (activeCount === 0) {
    if (pausedCount === 0) {
      return `You don't have any active courses. You can start up to ${MAX_ACTIVE_COURSES} courses.`;
    }

    return `You don't have any active courses. You have ${plural(pausedCount, 'paused course')} that can be resumed at any time, or you can start up to ${MAX_ACTIVE_COURSES} courses.`;
  }

  const activePart = plural(activeCount, 'active course');
  const remainingPart = `You can start ${plural(remaining, 'more course')}.`;

  if (pausedCount === 0) {
    return `You have ${activePart}. ${remainingPart}`;
  }

  return `You have ${activePart} and ${plural(pausedCount, 'paused course')}. ${remainingPart}`;
};
